export default __webpack_public_path__ + "static/jaeger copy-88cf785bdc54a6c5767f21c4bb3a6258.webp";